import React, { useMemo } from 'react';
import { Slider } from '../ui/slider';

export const LoanSlider = ({
  label,
  displayValue,
  value,
  onChange,
  min,
  max,
  step,
  minLabel,
  maxLabel,
  testIdPrefix,
}) => {
  const sliderValue = useMemo(() => [value], [value]);

  return (
    <div>
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm font-medium text-gray-600">{label}</span>
        <span className="text-lg font-bold text-cyan-700" data-testid={`${testIdPrefix}-value`}>
          {displayValue}
        </span>
      </div>
      <Slider
        value={sliderValue}
        onValueChange={(v) => onChange(v[0])}
        min={min}
        max={max}
        step={step}
        data-testid={`${testIdPrefix}-slider`}
      />
      <div className="flex justify-between text-xs text-gray-400 mt-2">
        <span>{minLabel}</span><span>{maxLabel}</span>
      </div>
    </div>
  );
};

export default LoanSlider;
